import React, { useMemo } from 'react'

export const UserName = ({ name, lastName }) => {
    const fullName = useMemo(() => {
        if (lastName)
            return `${name} ${lastName}`;
        else
            return name;
    }, [name, lastName]);
    return (
        <h2>{fullName}</h2>
    )
}
